/* NEWSLETTER-551: Koppelungen per CSS deaktivieren für den Zeitraum des Updates -> sofern das wieder mal benötigt wird, einfach den Kommentar entfernen
if ($('.ttgNewsletterContainer').length) {
    var newsletterOffline = '<div class="container ttgTourdataDetailseite"><div class="row"><div class="ttgNCEColouredBackground ttg-akutmeldungen mb-3"><div class="row mb-5"><div class="col-sm-1 col-xs-2"><span class="fas fa-triangle-exclamation rot fa-3x mr-2" aria-hidden="true"></span></div><div class="col-sm-11 col-xs-10"><h5>Newsletter-Anmeldung</h5><div class="mt-1"><p>Wir führen momentan Wartungsarbeiten durch. Bitte probieren Sie die Newsletteranmeldung später noch einmal.<br />Vielen Dank für Ihr Verständnis!</p></div></div></div></div></div></div>';
    $('.ttgNewsletterContainer').before(newsletterOffline).remove();
}
*/

if ($('.noBreadcrumb').length) {
    $('#ttgBreadCrumbs').remove();
}

// Initialer abonnierte Themen Check
if ($(".ttgNewsletterAktualisierung, .ttgNewsletterSpiceCrmAktualisierung").length) {
    $.each($('.form-control.check'), function() {
        if ($('#themenManagement').data('topicsabonniert').indexOf($(this).val()) >= 0) {
            $(this).prop('checked', true).data({
                lastValue: true
            });
        } else {
            $(this).prop('checked', false).data({
                lastValue: false
            });
        }
    });
}

KROT.setup($('.ttgNewsletterSubmitBtn.recaptcha').data('publickey'));

/* NEWSLETTER ANMELDEFORMULAR ABSCHICKEN */
$(".ttgNewsletterAnmeldung").on('click', '.ttgNewsletterAnmeldeBtn', function(e) {

    var $form = $(".ttgNewsletterAnmeldung");
    var nlFormInstance = $(".ttgNewsletterAnmeldung").parsley();

    if ($('#themenManagement').length) {

        // Collect Topics
        var topics = [];
        $.each($('#themenManagement .form-control.check:checked'), function() {
            topics.push($(this).val());
        });
        $('#collectTopicIds').val(topics.join());

        // Themenvalidierung
        if ($('#collectTopicIds').val().length <= 0) {
            $('#themenManagement').addClass('invalid');
            $('#themenManagement input').attr('aria-invalid', 'true').attr('aria-describedby', 'error-themen');
            $('#error-themen').text('Bitte wählen Sie mindestens ein Thema aus.');
            return;
        } else {
            $('#themenManagement').removeClass('invalid');
            $('#themenManagement input').removeAttr('aria-invalid').removeAttr('aria-describedby');
            $('#error-themen').text('');
        }

    }

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    if (nlFormInstance.isValid() === false) {
        // Fehler
    } else {

        e.preventDefault();

        //Formular Button deaktivieren
        $(".ttgNewsletterSubmitBtn")
            .attr("disabled", "disabled")
            .css('cursor', 'not-allowed');


        KROT.getSolution()
            .then((solution) => {

                $('input.newsletter-captchaeu-solution').val(JSON.stringify(solution));

                var formData = $form.serialize();

                $.ajax({
                    type: "POST",
                    url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77771",
                    data: formData,
                    beforeSend: function() {

                        var $alert = $form.closest('.responseHolder').find('.alert');
                        $alert.find('span.message').text('Sie werden angemeldet!');
                        $alert.show();

                        $('.ttgNewsletterContainer .text .errorMessage').hide();
                        $('.nlt_errorMessage').remove();

                    },
                    success: function(res) {

                        var response = $.parseJSON(res);
                        console.log(res);
                        $('.ttgNewsletterContainer h1').text(response.title);

                        // $('.ttgNewsletterContainer .text').empty().append( $('<p />').html(response.message) );
                        $('.ttgNewsletterContainer .text .einleitung').hide();

                        if (response.status === 'success') {
                            if ($('.ttgNewsletterContainer .responseHolder').length > 0) {
                                $('.ttgNewsletterContainer .responseHolder').hide();
                            }
                            $('.ttgNewsletterContainer form').fadeOut();
                            $('.ttgNewsletterContainer .text .successMessage').show();
                            if (response.conversionCode.length > 0) {
                                $('<iframe />').prop('src', window.location.href + '?type=77775&no_cache=1').appendTo($('.ttgNewsletterContainer')).css('display', 'none');
                            }
                        } else {
                            $('.ttgNewsletterContainer .text .errorMessage').show();

                            if ($('#themenManagement').length && response.nlt_errorMessage.indexOf('already exists') > 0) {
                                var email = $form.find('input[name="email"]').val();
                                $('<p />').addClass('nlt_errorMessage nlt_alreadyExist').html('Die E-Mail Adresse "' + email + '" ist bereits vorhanden. <a href="' + window.location.origin + '/index.php?id=' + $('body').data('pid') + '&action=abmeldung&email=' + email + '&hash=' + response.hash + '">Hier können die Themenabonnements angepasst werden</a> oder Sie benutzen eine andere E-Mail Adresse.').insertAfter($('.ttgNewsletterContainer .text .errorMessage'));
                            } else {
                                $('<p />').addClass('nlt_errorMessage').text(response.nlt_errorMessage).insertAfter($('.ttgNewsletterContainer .text .errorMessage'));
                            }

                        }

                    },
                    // error: function() {
                    //   console.log('error');
                    // },
                    complete: function() {
                        $form.closest('.responseHolder').find('.alert').fadeOut();
                    }
                });
            });

    }

    if ($('#themenManagement').length) {
        trackEvent('Formular', 'Newsletteranmeldung DOI unbestätigt', 'Themen-IDs: ' + $('#collectTopicIds').val());
    }

});

/* NEWSLETTER ABMELDEFORMULAR ABSCHICKEN */
$(".ttgNewsletterAbmeldung").submit(function(e) {
    e.preventDefault();

    var $form = $(this);

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    if ($form.find('ul.filled').length != 0) {
        return;
    } else {

        var formData = $form.serialize();
        $.ajax({
            type: "POST",
            url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77774",
            data: formData,
            beforeSend: function() {

                var $alert = $form.closest('.responseHolder').find('.alert');
                $alert.find('span.message').text('Sie werden abgemeldet!');
                $alert.show();

                $('.ttgNewsletterContainer .text .errorMessage').hide();
                $('.nlt_errorMessage').remove();

            },
            success: function(res) {

                var response = $.parseJSON(res);
                $('.ttgNewsletterContainer h1').text(response.title);

                // $('.ttgNewsletterContainer .text').empty().append( $('<p />').html(response.message) );
                $('.ttgNewsletterContainer .text .einleitung').hide();

                if (response.status === 'success') {
                    $('.ttgNewsletterContainer form').fadeOut();
                    $('.ttgNewsletterContainer .text .successMessage').show();
                } else {
                    $('.ttgNewsletterContainer .text .errorMessage').show();
                    $('<p />').addClass('nlt_errorMessage').text(response.nlt_errorMessage).insertAfter($('.ttgNewsletterContainer .text .errorMessage'));
                }

            },
            // error: function() {
            //   console.log('error');
            // },
            complete: function() {
                $form.closest('.responseHolder').find('.alert').fadeOut();
            }
        });

    }

});

/* NEWSLETTER AKTUALISIERUNG ABSCHICKEN */
$(".ttgNewsletterAktualisierung").submit(function(e) {
    e.preventDefault();

    var $form = $(this);

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    // if ($form.find('ul.filled').length != 0) {
    if ($form.find('.form-control.check:checked').length) {

        var formData = {
            newsletter_id: $form.find('input[name="newsletter_id"]').val(),
            recId: $form.find('input[name="recId"]').val(),
            action: 'UpdateRecipientTopics',
            topicActions: []
        };

        // Check ob/was pro Topic zu tun ist (add/del Action zuweisen)
        var topicsabonniert = '';
        $.each($('.form-control.check'), function() {
            var $cb = $(this);
            var topic = {};
            if ($cb.prop('checked') === false && $cb.data('lastValue') === true) {
                topic = {
                    id: $cb.val(),
                    action: 'delRecipientTopics'
                };
                formData.topicActions.push(topic);
                $cb.data('lastValue', false);
            } else if ($cb.prop('checked') === true && $cb.data('lastValue') === false) {
                topic = {
                    id: $cb.val(),
                    action: 'addRecipientTopics'
                };
                formData.topicActions.push(topic);
                $cb.data('lastValue', true);
            }
            if ($(this).prop('checked') === true) {
                topicsabonniert += $(this).val() + ',';
            }
        });

        if (formData.topicActions.length > 0) {
            $.ajax({
                type: "POST",
                url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77774", // andere Action !!!
                data: formData,
                beforeSend: function() {

                    $form.removeClass('success');
                    var $alert = $form.closest('.responseHolder').find('.alert');
                    $alert.find('span.message').text('Themenabos werden aktualisiert!');
                    $alert.show();

                },
                success: function(res) {

                    $('#themenManagement').data('topicsabonniert', topicsabonniert);
                    $form.addClass('success').find('fieldset');

                },
                // error: function() {
                //   console.log('error');
                // },
                complete: function() {
                    $form.closest('.responseHolder').find('.alert').fadeOut();
                    setTimeout(function() {
                        $form.removeClass('success');
                    }, 2000);
                }
            });
        }

    } else {

        // wenn der User alle Themen abwählt soll er gänzlich abgemeldet werden
        $(".ttgNewsletterAbmeldung").trigger('submit');

    }

});

/* SPICE-CRM NEWSLETTER ABMELDEFORMULAR ABSCHICKEN */
$(".ttgNewsletterSpiceCrmAbmeldung").submit(function(e) {
    e.preventDefault();
    var $form = $(this);

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    if ($form.find('ul.filled').length != 0) {
        return;
    } else {

        var formData = $form.serialize();
        $.ajax({
            type: "POST",
            url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77774",
            data: formData,
            beforeSend: function() {

                var $alert = $form.closest('.responseHolder').find('.alert');
                $alert.find('span.message').text('Sie werden abgemeldet!');
                $alert.show();

                $('.ttgNewsletterContainer .text .errorMessage').hide();
                $('.nlt_errorMessage').remove();

            },
            success: function(res) {

                var response = $.parseJSON(res);
                $('.ttgNewsletterContainer h1').text(response.title);

                // $('.ttgNewsletterContainer .text').empty().append( $('<p />').html(response.message) );
                $('.ttgNewsletterContainer .text .einleitung').hide();

                if (response.status === 'success') {
                    $('.ttgNewsletterContainer form').fadeOut();
                    $('.ttgNewsletterContainer .text .successMessage').show();
                } else {
                    $('.ttgNewsletterContainer .text .errorMessage').show();
                    $('<p />').addClass('nlt_errorMessage').text(response.nlt_errorMessage).insertAfter($('.ttgNewsletterContainer .text .errorMessage'));
                }

            },
            // error: function() {
            //   console.log('error');
            // },
            complete: function() {
                $form.closest('.responseHolder').find('.alert').fadeOut();
            }
        });

    }

});

/* SPICE-CRM NEWSLETTER AKTUALISIERUNG ABSCHICKEN */
$(".ttgNewsletterSpiceCrmAktualisierung").submit(function(e) {
    e.preventDefault();

    var $form = $(this);

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    // if ($form.find('ul.filled').length != 0) {
    if ($form.find('.form-control.check:checked').length) {

        var formData = {
            SubscriberID: $form.find('input[name="SubscriberID"]').val(),
            MandantKey: $form.find('input[name="MandantKey"]').val(),
            action: 'UpdateNewsletterTopicsProxy',
            topicActions: []
        };

        // Check ob/was pro Topic zu tun ist (add/del Action zuweisen)
        var topicsabonniert = '';
        $.each($('.form-control.check'), function() {
            var $cb = $(this);
            var topic = {};
            if ($cb.prop('checked') === true) {
                topic = {
                    id: $cb.val()
                };
                formData.topicActions.push(topic);
                console.log(topic);
            }
            if ($(this).prop('checked') === true) {
                topicsabonniert += $(this).val() + ',';
            }
        });

        if (formData.topicActions.length > 0) {
            $.ajax({
                type: "POST",
                url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77774", // andere Action !!!
                data: formData,
                beforeSend: function() {

                    $form.removeClass('success');
                    var $alert = $form.closest('.responseHolder').find('.alert');
                    $alert.find('span.message').text('Themenabos werden aktualisiert!');
                    $alert.show();

                },
                success: function(res) {

                    $('#themenManagement').data('topicsabonniert', topicsabonniert);
                    $form.addClass('success').find('fieldset');

                },
                // error: function() {
                //   console.log('error');
                // },
                complete: function() {
                    $form.closest('.responseHolder').find('.alert').fadeOut();
                    setTimeout(function() {
                        $form.removeClass('success');
                    }, 2000);
                }
            });
        }

    } else {

        // wenn der User alle Themen abwählt soll er gänzlich abgemeldet werden
        $(".ttgNewsletterSpiceCrmAbmeldung").trigger('submit');

    }

});

/* NEWSLETTER WEITEREMPFEHLUNGSFORMULAR ABSCHICKEN */
$(".ttgNewsletterWeiterempfehlung").submit(function(e) {
    e.preventDefault();

    var $form = $(this);

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    if ($form.find('ul.filled').length != 0) {
        return;
    } else {

        var formData = $form.serialize();
        $.ajax({
            type: "POST",
            url: "index.php?id=" + $form.find('input[name="pid"]').val() + "&type=77776",
            data: formData,
            beforeSend: function() {
                var $alert = $form.closest('.responseHolder').find('.alert');
                $alert.find('span.message').text('Weiterempfehlung wird gesendet!');
                $alert.show();

                $('.ttgNewsletterContainer .text .errorMessage').hide();
                $('.nlt_errorMessage').remove();

            },
            success: function(res) {
                var response = $.parseJSON(res);
                $('.ttgNewsletterContainer h1').text(response.title);

                // $('.ttgNewsletterContainer .text').empty().append( $('<p />').html(response.message) );
                $('.ttgNewsletterContainer .text .einleitung').hide();

                if (response.status === 'success') {
                    $('.ttgNewsletterContainer form').fadeOut();
                    $('.ttgNewsletterContainer .text .successMessage').show();
                } else {
                    $('.ttgNewsletterContainer .text .errorMessage').show();
                }

            },
            // error: function() {
            //   console.log('error');
            // },
            complete: function() {
                $form.closest('.responseHolder').find('.alert').fadeOut();
            }
        });

    }
});
